import React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import LockIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import { isMobile } from "react-device-detect";
import { withStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';

import firebase from './../firebase.js';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";
//import $ from 'jquery';
import moment from 'moment';

const styles = theme => ({
    root: {
      width: '100%',
    },
    layout: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: useTheme().spacing(3),
        marginRight: useTheme().spacing(3),
        [useTheme().breakpoints.up(400 + useTheme().spacing(3) * 2)]: {
          width: 400,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
      paper: {
        marginTop: useTheme().spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${useTheme().spacing(2)}px ${useTheme().spacing(3)}px ${useTheme().spacing(3)}px`,
      },
      avatar: {
        margin: useTheme().spacing(1),
        backgroundColor: useTheme().palette.secondary.main,
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: useTheme().spacing(1),
      },
      submit: {
        marginTop: useTheme().spacing(3),
      },
      centeralign: {
        flexGrow: 1,
        textAlign: 'center',
      },
      contentbody: {
        height: '85vh',
      }
});

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        count_logs: 0,
        myip: '',
        mylocation: ''
        }
        this.email = React.createRef();
        this.password = React.createRef();
    }

    state = {
        errorlogin: '',
    }

    componentDidMount() {
      //$("div.container").css({display:'none'});
      //firebase.database().ref("/logs").on('value', snapshot => {
        const db = getDatabase();
        get(ref(db,'/logs')).then((snapshot) => {
        var select_logs = []
        snapshot.forEach(child => {
          var data = child.val()
          select_logs.push({
              id: data.id,
              status: data.status,
              message: data.message,
              agent: data.agent,
              ip: data.ip,
              location: data.location,
              user_id: data.user_id,
              time: data.time,
            })
        this.setState({ count_logs: select_logs.length })
        
        })
      })
    }

    login = (e) => {
        e.preventDefault();

        //const auth = firebase.auth();
        try{
          const auth = getAuth();
          signInWithEmailAndPassword(auth,this.email.current.value,this.password.current.value)
            .then(() => { 
              this.userauth_login(this.email.current.value);/*window.location.reload(false);*/window.location.href = "#/dashboard"; })
            .catch(error => {   
              //alert(error.code)
              this.setState({ errorlogin: 'Invalid user or password' });
              setTimeout(function(){ 
                this.setState({ errorlogin: '',email: '',password: '' });
              }.bind(this), 2000);
              switch(error.code) {
                case 'auth/user-not-found':
                      alert('Incorect User or Password !');
                      break;
                case 'auth/wrong-password':
                  alert('Incorect User or Password !');
                  break;
                default:
                  break;
            }
          });
        }catch(err){
            alert("Error : ", err);
        }
        
    }

    userauth_login(id){
            localStorage.setItem('authlogin', 'true');
            localStorage.setItem('user_id', id);
            fetch('http://ip-api.com/json')
            .then(res => res.json())
            .then((data) => {
              setTimeout(function(){ 
                this.setState({ myip: data.query, mylocation: data.country+'#'+data.city })
              }.bind(this), 300);
            })
            //window.location.reload();
            //return <Redirect to="/reactmaterial/"/>;
            //alert('logout!'+ localStorage.getItem('authlogin'));
            
            setTimeout(function(){ 
            var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
            /*var refdb = firebase.database().ref('/logs').push();
            refdb = refdb.toString().slice(-20);
            
            let updateData = firebase.database().ref("/logs").child(refdb);
            updateData.child("id").set(this.state.count_logs+1);
            updateData.child("status").set('1');
            updateData.child("message").set('User Login');
            updateData.child("agent").set(navigator.userAgent);
            updateData.child("ip").set(this.state.myip);
            updateData.child("location").set(this.state.mylocation);
            updateData.child("user_id").set(id);
            updateData.child("time").set(curtime);*/
            const db = getDatabase();
            var refdb = push(ref(db,'/logs'));
              //refdb_ref = refdb.toString().slice(-20);

            set(refdb,{
              id:this.state.count_logs+1,
              status:'1',
              message:'User Login',
              agent:String(navigator.userAgent),
              ip: String(this.state.myip),
              location:String(this.state.mylocation),
              user_id:String(id),
              time:String(curtime)
            });
            window.location.href = "#/dashboard";
            }.bind(this), 600);
    }

    render() {
        const { classes } = this.props;

        return (
        <div className='col-6 mx-auto'>
          <h2>Login</h2>
          <hr/>
          <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <div className={isMobile?classes.errorloginm:classes.errorlogin}>{this.state.errorlogin}</div>
            <form className={classes.form} method="post" onSubmit={this.login.bind(this)}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="email">Email Address</InputLabel>
                <Input
                  type="email"
                  id="email" 
                  name="email"
                  inputRef={this.email}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">Password</InputLabel>
                <Input
                  name="password"
                  type="password"
                  id="password"
                  inputRef={this.password}
                />
              </FormControl>
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Sign in
              </Button>
            </form>
          </Paper>
        </main>
      </React.Fragment>
        </div>
      );
    }
}

export default withStyles(styles)(Login);
    